import { FormType } from '../../../form-types';

export const peFollowup: FormType = {
  name: 'PE Follow Up Questionnaire',
  questions: [
    'peFollowup_sex',
    'peFollowup_height',
    'peFollowup_weight',
    {
      key: 'peFollowup_healthChanges',
      next: {
        condition: {
          'peFollowup_healthChanges.peFollowup_healthChanges_yes': true
        },
        key: 'peFollowup_healthChanges_details',
        els: 'peFollowup_medicationStatus'
      }
    },
    'peFollowup_healthChanges_details',
    {
      key: 'peFollowup_medicationStatus',
      next: {
        condition: {
          'peFollowup_medicationStatus.peFollowup_medicationStatus_notWell':
            true
        },
        key: 'peFollowup_medicationStatus_details',
        els: 'peFollowup_sideEffects'
      }
    },
    'peFollowup_medicationStatus_details',
    {
      key: 'peFollowup_sideEffects',
      next: {
        condition: {
          'peFollowup_sideEffects.peFollowup_sideEffects_yes': true
        },
        key: 'peFollowup_sideEffects_details',
        els: 'peFollowup_otherInformation'
      }
    },
    'peFollowup_sideEffects_details',
    'peFollowup_otherInformation',
    {
      key: 'peFollowup_truthConsent',
      next: {
        condition: {
          'peFollowup_truthConsent.peFollowup_truthConsent_disagree': true
        },
        key: 'peFollowup_ineligible',
        els: 'peFollowup_treatmentConsent'
      }
    },
    {
      key: 'peFollowup_treatmentConsent',
      next: {
        condition: {
          'peFollowup_treatmentConsent.peFollowup_treatmentConsent_disagree':
            true
        },
        key: 'peFollowup_ineligible',
        els: 'peFollowup_complete'
      }
    },
    'peFollowup_ineligible',
    'peFollowup_complete'
  ]
};
